import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Header from "components/ui/Header";
import NotFound from "pages/NotFound";
import Homepage from "pages/homepage-mediterranean-restaurant-experience";
import OurStory from "pages/our-story-heritage-authenticity";
import InteractiveMenu from "pages/interactive-menu-culinary-discovery";
import OrderOnline from "pages/order-online-streamlined-experience";
import ContactLocation from "pages/contact-location-welcoming-connection";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Header />
        <RouterRoutes>
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage-mediterranean-restaurant-experience" element={<Homepage />} />
          <Route path="/our-story-heritage-authenticity" element={<OurStory />} />
          <Route path="/interactive-menu-culinary-discovery" element={<InteractiveMenu />} />
          <Route path="/order-online-streamlined-experience" element={<OrderOnline />} />
          <Route path="/contact-location-welcoming-connection" element={<ContactLocation />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;